// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RNg1","field":"styles_field__1LLLA","fieldCol":"styles_fieldCol__1u_9t","diffCol":"styles_diffCol__2RswB","diff":"styles_diff__1PrCR"};